/**
 * @generated SignedSource<<67d70b283e85b19f53ebf635374534f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ConferenceProviderOptions = "GOOGLE" | "NONE" | "TEAMS" | "ZOOM";
export type UserPreferencesRefetchZoomIntegrationQuery$variables = {};
export type UserPreferencesRefetchZoomIntegrationQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly zoom: {
        readonly hasMeetingWriteScope: boolean;
      } | null;
    };
    readonly settings: {
      readonly preferredConferenceProvider: ConferenceProviderOptions | null;
    };
  };
};
export type UserPreferencesRefetchZoomIntegrationQuery = {
  response: UserPreferencesRefetchZoomIntegrationQuery$data;
  variables: UserPreferencesRefetchZoomIntegrationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredConferenceProvider",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasMeetingWriteScope",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPreferencesRefetchZoomIntegrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZoomUserNode",
                "kind": "LinkedField",
                "name": "zoom",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserPreferencesRefetchZoomIntegrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZoomUserNode",
                "kind": "LinkedField",
                "name": "zoom",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21fd8fc4459cfd086b1141dcb512988c",
    "id": null,
    "metadata": {},
    "name": "UserPreferencesRefetchZoomIntegrationQuery",
    "operationKind": "query",
    "text": "query UserPreferencesRefetchZoomIntegrationQuery {\n  viewer {\n    settings {\n      preferredConferenceProvider\n    }\n    integrations {\n      zoom {\n        hasMeetingWriteScope\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a46cceaa00dbcabf7e84b1a624b4f60";

export default node;
